import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import { ElementFactory, checkNotOverLimit } from "./util";
export function StoryblokRenderer({ block , components , props , componentsWithWrapper , limitedItems  }) {
    if (Array.isArray(block)) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: block.map((blockElement, index)=>checkNotOverLimit(blockElement, limitedItems) ? /*#__PURE__*/ _createElement("div", {
                    ...storyblokEditable(blockElement),
                    key: index
                }, ElementFactory(blockElement, components, props, componentsWithWrapper)) : null)
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        ...storyblokEditable(block),
        children: ElementFactory(block, components, props)
    });
}
